import { render, staticRenderFns } from "./AuthorNameText.vue?vue&type=template&id=e3ddd496&scoped=true"
var script = {}
import style0 from "./AuthorNameText.vue?vue&type=style&index=0&id=e3ddd496&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3ddd496",
  null
  
)

export default component.exports